import * as ng from 'angular';

export const GetWatchCountService: Function = () => {

    function getWatchCount() {

        let total = 0;
        // angularJS denotes new scopes in the HTML markup by appending the
        // class "ng-scope" to appropriate elements. As such, rather than
        // attempting to navigate the hierarchical Scope tree, we can simply
        // query the DOM for the individual scopes. Then, we can pluck the
        // watcher-count from each scope.
        // --
        // nOTE: Ordinarily, it would be a HUGE SIN for an AngularJS service
        // to access the DOM (Document Object Model). But, in this case,
        // we're not really building a true AngularJS service, so we can
        // break the rules a bit.

        ng.element('.ng-scope').each(
            function ngScopeIterator() {
                // get the scope associated with this element node.
                let scope: any = $(this).scope();
                // the $$watchers value starts out as NULL.
                total += scope.$$watchers
                    ? scope.$$watchers.length
                    : 0
                    ;
            }
        );
        return (total);
    }

    // for convenience, let's serialize the above method and convert it to
    // a bookmarklet that can easily be run on ANY AngularJS page.
    this.bookmarklet = (
        'javascript:alert(\'Watchers:\'+(' +
        getWatchCount.toString()
            .replace(/\/\/.*/g, ' ')
            .replace(/\s+/g, ' ') +
        ')());void(0);'
    );
    return (getWatchCount);
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/services/get-watch-count.service.ts